import { Entity, EntityType } from '~/types/Entity';
import { Nullable } from '~/types/Nullable';

import { EntityContextItem } from '../types/chatbot';

const preSigEntityTypes: EntityType[] = ['ticket'];
const preSigContext = ['document_version'];

const postSigContext = [
  'all_documents',
  'document',
  'folder',
  'document_group',
  'all_results',
];

export const testEntityAndContextCompatibility = (
  entity: Nullable<Entity<EntityType>>,
  selectedContext: Nullable<EntityContextItem>,
) => {
  if (!selectedContext || !entity) {
    return true;
  }
  const isPreSigEntity = preSigEntityTypes.includes(entity.type);
  const isPreSigContext = preSigContext.includes(
    selectedContext.type ?? 'all_documents',
  );
  const isPostSigContext = postSigContext.includes(
    selectedContext.type ?? 'all_documents',
  );
  const isIncompatible =
    (isPreSigEntity && isPostSigContext) ||
    (!isPreSigEntity && isPreSigContext);
  return !isIncompatible;
};
